// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".color--primary[data-v-752a01d0]{color:#0c83d3}.form--group[data-v-752a01d0]{display:block}.form--group .val-error[data-v-752a01d0]{margin-top:8px}.terms--conditions[data-v-752a01d0]{font-size:.9rem}", ""]);
// Exports
module.exports = exports;
